











import Vue from 'vue'
import { Article } from '@/model/Article'
import BackgroundLayout from '@/components/BackgroundLayout.vue'

export default Vue.extend({
  name: 'BackgroundArticle',
  components: {
    BackgroundLayout,
  },
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.fetch()
  },
  data: () => ({
    article: null as Article | null,
  }),
  methods: {
    fetch: function () {
      this.$api
        .get('/articles/slug/' + this.slug)
        .then((response) => {
          this.article = response.data
        })
        .catch(() => this.$router.push('/404'))
    },
  },
  watch: {
    $route: function () {
      this.fetch()
    },
  },
})
